import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import ticketStore from './ticketStore.js'
// import companyStore from './companyStore.js'
import actionStore from './actionStore.js'
import previewStore from './previewStore.js'
import siteStore from './siteStore.js'
import viaList from './viaList.js'
import categoryStore from './categoryStore.js'
import conferService from './conferService.js'
import workTaskStore from './workTaskStore.js'
// Vue.use(Vuex)
export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        ticketStore,
        // companyStore,
        actionStore,
        previewStore,
        siteStore,
        viaList,
        categoryStore,
        conferService,
        workTaskStore
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js